export default {
  menuData: {},
  detailedCategory: {},
  tempData: {},
  selectedDatas: {},
};
